import { z } from "zod";
import { zodSortField } from "@/lib/utils";

const alphaNameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;

export const getDocumentSignatairesRequestSchema = z.object({
  sort: zodSortField([
    "documentCode",
    "signerIdentifier",
    "firstName",
    "lastName",
    "createdAt",
  ]).optional(),
});

const documentSignataireBaseSchema = z.object({
  documentCode: z
    .string()
    .trim()
    .toUpperCase()
    .regex(
      /^[A-Z]{3}$/,
      "Le document doit contenir 3 caractères alphabétiques",
    ),
  signerIdentifier: z
    .string()
    .trim()
    .regex(
      /^[A-Za-z0-9_-]+$/,
      "L'identifiant signataire doit être alphanumérique (tirets et underscores autorisés)",
    )
    .max(50, "L'identifiant signataire est limité à 50 caractères"),
  firstName: z
    .string()
    .trim()
    .toUpperCase()
    .regex(
      alphaNameRegex,
      "Le prénom doit être alphabétique (espaces, apostrophes et tirets autorisés)",
    )
    .max(50, "Le prénom est limité à 50 caractères"),
  lastName: z
    .string()
    .trim()
    .toUpperCase()
    .regex(
      alphaNameRegex,
      "Le nom doit être alphabétique (espaces, apostrophes et tirets autorisés)",
    )
    .max(50, "Le nom est limité à 50 caractères"),
});

export const addDocumentSignataireSchema = documentSignataireBaseSchema;

export const editDocumentSignataireSchema = documentSignataireBaseSchema.extend(
  {
    id: z.number().int().positive(),
    isActive: z.boolean().default(true),
    versionNote: z.string().max(500).optional(),
  },
);

export const deleteDocumentSignataireSchema = z.object({
  id: z.number().int().positive(),
});
